import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MU_UPATE_AUTH } from "store/index";
import CryptoJS from "crypto-js";
export default {
  data: function data() {
    var _this = this;

    var validateSurePass = function validateSurePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== _this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    var validatePhone = function validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号码格式不正确!"));
      } else {
        callback();
      }
    };

    return {
      show1: true,
      show2: false,
      show3: false,
      count: 60,
      ruleForm: {
        name: "",
        cardNumber: "",
        password: "",
        phone: "",
        userType: 2,
        surePassword: "",
        schoolId: "",
        captcha: ""
      },
      schoolInfo: [],
      rules: {
        name: [{
          required: true,
          message: "姓名不能为空",
          trigger: "blur"
        }],
        schoolId: [{
          required: true,
          message: "请选择学校",
          trigger: "blur"
        }],
        cardNumber: [{
          required: true,
          message: "身份证号不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "密码不能为空",
          trigger: "blur"
        }],
        captcha: [{
          required: true,
          message: "验证码不能为空",
          trigger: "blur"
        }],
        phone: [{
          validator: validatePhone,
          trigger: "blur"
        }],
        surePassword: [{
          validator: validateSurePass,
          trigger: "blur"
        }]
      },
      check: false
    };
  },
  props: {
    schoolId: {
      type: String,
      default: ""
    },
    schoolName: {
      type: String,
      default: ""
    },
    typeof: {
      type: String,
      default: ""
    }
  },
  computed: {
    association: function association() {
      return this.$store.state.association;
    }
  },
  methods: {
    toSelectUnit: function toSelectUnit() {
      this.$router.push({
        name: "schoolList",
        params: {
          enterType: 'register',
          typeof: this.typeof
        }
      });
    },
    verificationMobile: function verificationMobile() {
      var re = /^1\d{10}$/;

      if (re.test(this.ruleForm.phone)) {
        return true;
      } else {
        this.$message.warning("手机号格式不正确");
        return false;
      }
    },
    goHome: function goHome() {
      if (this.typeof == "jdtestExam") {
        window.location.href = "http://jdmock.chinahoteledu.com/login";
      } else if (this.typeof == "fdtestExam") {
        window.location.href = "http://fdmock.chinahoteledu.com/login";
      } else if (this.typeof == "train") {
        window.location.href = "http://teah5.chinahoteledu.com/login";
      } else if (this.typeof == "0") {
        this.$store.dispatch(MU_UPATE_AUTH).then(function () {});
        this.$router.push({
          name: "xIndex"
        });
      }
    },
    register: function register(formName) {
      var _this2 = this;

      if (this.schoolId == "") {
        return _Toast({
          message: "请选择学校",
          type: "fail"
        });
      } else {
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this2.sureRegister();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    sureRegister: function sureRegister() {
      var _this3 = this;

      this.$http.post("/api/XOrg/XLogin/register_new", {
        userType: this.ruleForm.userType,
        cardNumber: this.ruleForm.cardNumber,
        phone: this.ruleForm.phone,
        verfyCode: this.ruleForm.captcha,
        name: this.ruleForm.name,
        schoolId: this.ruleForm.schoolId,
        password: this.ruleForm.password,
        associationId: this.association.Id
      }).then(function (rst) {
        if (rst.code > 0) {
          _Toast({
            message: rst.msg,
            type: "success"
          });

          _this3.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {});

          _this3.goHome();
        } else {
          _Toast({
            message: rst.msg,
            type: "fail"
          });
        }
      });
    },
    //验证码
    sendMessage: function sendMessage() {
      var _this4 = this;

      var once = true;
      var str_ = Date.parse(new Date()) / 1000;
      var str = this.encryption(str_);
      var str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      debugger;
      console.log(this.ruleForm.phone);
      str1 = s1 + "s" + s2;

      if (once) {
        var that = this;
        this.$http.post("/api/XOrg/XLogin/sendCode", {
          verifyInfo: that.ruleForm.phone,
          str: str,
          str1: str1
        }).then(function (rst) {
          if (rst.code > 0) {
            _this4.$message.success(rst.msg);

            _this4.verifyCode = rst.verifyCode;
            var TIME_COUNT = 60;

            if (!_this4.timer) {
              _this4.count = TIME_COUNT;
              _this4.show1 = false;
              _this4.show2 = true;
              _this4.show3 = false;
              _this4.timer = setInterval(function () {
                if (_this4.count > 0 && _this4.count <= TIME_COUNT) {
                  _this4.count--;
                  once = false;
                } else {
                  _this4.show1 = false;
                  _this4.show2 = false;
                  _this4.show3 = true;
                  clearInterval(_this4.timer);
                  _this4.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            _this4.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function encryption(str) {
      var Base64 = require("js-base64").Base64;

      return Base64.encode(str);
    }
  }
};